import Handler from '@/core/domain/usecase/handler';

const createCodeRepository = (axios) => async (data) => {
  try {
    const response = await axios.post(`/code`,
      data
    )
    return response.data
  } catch (err) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createCodeRepository
